import CheckCircleIcon from 'components/ReusableComponents/Icons/CheckCircle'
import { CrossIcon } from 'components/ReusableComponents/Icons/Cross'
import ExclamationIcon from 'components/ReusableComponents/Icons/Exclamation'
import moment from 'moment'
import ReactTooltip from 'react-tooltip'

import styles from './FeatureStatuses.module.scss'

const features = [
  {
    featureGroupTitle: '',
    features: [
      {
        title: 'Services & fees'
      },
      {
        title: 'Arrivals & In-house'
      },
      {
        title: 'Bookings'
      }
    ]
  },
  {
    featureGroupTitle: 'Analytics',
    features: [
      {
        title: 'Subscribers'
      },
      {
        title: 'Outreach'
      },
      {
        title: 'OTA Outreach'
      },
      {
        title: 'Conversions'
      },
      {
        title: 'Reviews'
      }
    ]
  },
  {
    featureGroupTitle: 'Messaging',
    features: [
      {
        title: 'Guest Messaging'
      },
      {
        title: 'Chatbot'
      },
      {
        title: 'Text blast & Announcements'
      }
    ]
  },
  {
    featureGroupTitle: 'Automated Messages',
    features: [
      {
        title: 'Campaigns'
      },
      {
        title: 'OTA Campaigns'
      }
    ]
  }
]

function generateSingleFeatureStatusWithReason({ title, hotelParameters }) {
  const {
    isPmsSyncing,
    hasPhoneNumber,
    hasPhoneNumberWithVoiceAndText,
    isChurned,
    isCampaignRegisteryComplete,
    enrichedGuestPercentage,
    inviteBackIsDisabled,
    hasReservationHotline,
    hasServiceStarted,
    onlySendsOTAMessages,
    areMarketingCampaignsEnabled,
    areOTAMarketingCampaignsEnabled,
    OTArateCodesCount,
    areReviewCampaignsEnabled,
    hasTripAdvisorLink,
    hasMessagingService,
    hasPlatformAccessFee,
    hasMarketing,
    isChatBotEnabled,
    isUsingDefaultOpera,
    hasChatbotResponses
  } = hotelParameters

  switch (title) {
    case 'Services & fees':
      if (!hasMessagingService && !hasMarketing && !hasPlatformAccessFee) {
        return {
          status: 'Bad',
          reason: 'No services'
        }
      }

      if (!hasMessagingService) {
        return {
          status: 'Warn',
          reason: 'No messaging service'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Warn',
          reason: 'No marketing service'
        }
      } else if (!hasPlatformAccessFee) {
        return {
          status: 'Warn',
          reason: 'No platform access fee'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Arrivals & In-house':
      if (!isPmsSyncing) {
        return {
          status: 'Warn',
          reason: 'PMS is not syncing'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Bookings':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'No marketing service'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Subscribers':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'No marketing service'
        }
      } else if (!hasPhoneNumberWithVoiceAndText) {
        return {
          status: 'Bad',
          reason: 'No phone number with voice and text'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Outreach':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'No marketing service'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areMarketingCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Not all marketing campaigns are enabled'
        }
      } else if (inviteBackIsDisabled) {
        return {
          status: 'Bad',
          reason: 'AutoInvite is disabled'
        }
      } else if (!hasReservationHotline) {
        return {
          status: 'Bad',
          reason: 'No reservation hotline'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (onlySendsOTAMessages) {
        return {
          status: 'Bad',
          reason: 'Only sends OTA messages'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Conversions': {
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'No marketing service'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areMarketingCampaignsEnabled || !areOTAMarketingCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Not all marketing campaigns are enabled'
        }
      } else if (inviteBackIsDisabled) {
        return {
          status: 'Bad',
          reason: 'AutoInvite is disabled'
        }
      } else if (!hasReservationHotline) {
        return {
          status: 'Bad',
          reason: 'No reservation hotline'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    }
    case 'OTA Outreach':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'No marketing service'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areOTAMarketingCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Not all marketing campaigns are enabled'
        }
      } else if (inviteBackIsDisabled) {
        return {
          status: 'Bad',
          reason: 'AutoInvite is disabled'
        }
      } else if (!hasReservationHotline) {
        return {
          status: 'Bad',
          reason: 'No reservation hotline'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (OTArateCodesCount === 0) {
        return {
          status: 'Bad',
          reason: 'No OTA rate codes'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Reviews':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'No marketing service'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areReviewCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Review campaigns are not enabled'
        }
      } else if (!hasTripAdvisorLink) {
        return {
          status: 'Bad',
          reason: 'No TripAdvisor link'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Guest Messaging':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMessagingService) {
        return {
          status: 'Bad',
          reason: 'Messaging service is not enabled'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (isUsingDefaultOpera) {
        return {
          status: 'Warn',
          reason: 'Using Opera default reports'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Chatbot':
      if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!isChatBotEnabled) {
        return {
          status: 'Bad',
          reason: 'Chatbot is not enabled'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (!hasChatbotResponses) {
        return {
          status: 'Warn',
          reason: 'Chatbot responses are not set'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Text blast & Announcements':
      if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Campaigns':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'No marketing service'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areMarketingCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Not all marketing campaigns are enabled'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (onlySendsOTAMessages) {
        return {
          status: 'Bad',
          reason: 'Only sends OTA messages'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'OTA Campaigns':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'No marketing service'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areOTAMarketingCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Not all OTA campaigns are enabled'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (OTArateCodesCount < 1) {
        return {
          status: 'Bad',
          reason: 'No rate codes'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    default:
      return {
        status: 'Good'
      }
  }
}

function generateFeatureStatuses(hotelParameters) {
  return features.map(featureGroup => {
    const featuresWithStatus = featureGroup.features.map(feature => {
      const featureStatus = generateSingleFeatureStatusWithReason({
        title: feature.title,
        hotelParameters
      })
      return {
        title: feature.title,
        status: featureStatus.status,
        reason: featureStatus?.reason || ''
      }
    })

    return {
      featureGroupTitle: featureGroup.featureGroupTitle,
      features: featuresWithStatus
    }
  })
}

const FeatureRow = ({ title, status, reason }) => (
  <div className={styles.featureRow} data-tip={reason} data-for="featureStatusTooltip">
    <div className={styles.featureTitle}>{title}</div>
    <div className={styles.featureStatus}>
      {status === 'Good' && <CheckCircleIcon className={styles.checkIcon} />}
      {status === 'Bad' && <CrossIcon className={styles.crossIcon} />}
      {status === 'Warn' && <ExclamationIcon className={styles.exclamationIcon} />}
    </div>
  </div>
)

const FeatureStatuses = ({
  phoneNumbers,
  status,
  tcrBrandId,
  tcrCampaignId,
  inviteBackIsDisabled,
  reservationHotLine,
  serviceStartDate,
  onlySendsOTAMessages,
  reviewTripAdvisorPage,
  subscriptions,
  isChatBotEnabled,
  isUsingDefaultOpera,
  enrichedGuestPercentage,
  areMarketingCampaignsEnabled,
  areOTAMarketingCampaignsEnabled,
  areReviewCampaignsEnabled,
  OTArateCodesCount,
  hasChatbotResponses,
  isPmsSyncing
}) => {
  // existing data

  const hasPhoneNumber = phoneNumbers.filter(p => p.status === 'Active').length > 0

  const hasPhoneNumberWithVoiceAndText =
    phoneNumbers.filter(p => p.status === 'Active' && p.capability === 'VoiceAndText')
      .length > 0

  const isChurned = status === 'Churned'

  const isCampaignRegisteryComplete = tcrBrandId && tcrCampaignId

  const hasReservationHotline = !!reservationHotLine

  const hasServiceStarted = moment().isAfter(moment(serviceStartDate))

  const hasTripAdvisorLink = !!reviewTripAdvisorPage

  const hasMessagingService = subscriptions.some(
    s =>
      s.plan === 'Messaging' &&
      ((moment().isAfter(s.startDate) && moment().isBefore(s.endDate)) ||
        (moment().isAfter(s.startDate) && !s.endDate))
  )

  const hasPlatformAccessFee = subscriptions.some(
    s =>
      s.plan === 'PlatformAccessFee' &&
      ((moment().isAfter(s.startDate) && moment().isBefore(s.endDate)) ||
        (moment().isAfter(s.startDate) && !s.endDate))
  )

  const hasMarketing = subscriptions.some(
    s =>
      (s.plan === 'Marketing' || s.plan === 'MarketingWithCommission') &&
      ((moment().isAfter(s.startDate) && moment().isBefore(s.endDate)) ||
        (moment().isAfter(s.startDate) && !s.endDate))
  )

  const hotelParameters = {
    isPmsSyncing,
    hasPhoneNumber,
    hasPhoneNumberWithVoiceAndText,
    isChurned,
    isCampaignRegisteryComplete,
    enrichedGuestPercentage,
    inviteBackIsDisabled,
    hasReservationHotline,
    hasServiceStarted,
    onlySendsOTAMessages,
    areMarketingCampaignsEnabled,
    areOTAMarketingCampaignsEnabled,
    OTArateCodesCount,
    areReviewCampaignsEnabled,
    hasTripAdvisorLink,
    hasMessagingService,
    hasPlatformAccessFee,
    hasMarketing,
    isChatBotEnabled,
    isUsingDefaultOpera,
    hasChatbotResponses
  }

  const featuresWithStatuses = generateFeatureStatuses(hotelParameters)

  const totalFeatureCount = featuresWithStatuses.reduce(
    (acc, featureGroup) => acc + featureGroup.features.length,
    0
  )

  const totalGoodFeatureCount = featuresWithStatuses.reduce(
    (acc, featureGroup) =>
      acc + featureGroup.features.filter(feature => feature.status !== 'Bad').length,
    0
  )

  return (
    <div className={styles.featureStatuses}>
      <ReactTooltip id="featureStatusTooltip" place="right" type="dark" effect="solid" />
      <div className={styles.titleHolder}>
        <span className={styles.boxTitle}>Feature status</span>
        <span
          className={styles.statusCountPill}
          style={{
            backgroundColor:
              totalFeatureCount === totalGoodFeatureCount ? '#D8FEDA' : '#F5E6E6',
            color: totalFeatureCount === totalGoodFeatureCount ? '#409144' : '#FF4545'
          }}
        >
          {totalGoodFeatureCount}/{totalFeatureCount} healthy
        </span>
      </div>
      <div className={styles.featuresHolder}>
        {generateFeatureStatuses(hotelParameters).map(
          ({ featureGroupTitle, features }) => (
            <div key={featureGroupTitle} className={styles.featureGroup}>
              {featureGroupTitle && (
                <div className={styles.featureGroupTitle}>{featureGroupTitle}</div>
              )}
              {features.map(({ title, status, reason }) => (
                <FeatureRow key={title} title={title} status={status} reason={reason} />
              ))}
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default FeatureStatuses
